const DefaultAvatarIcon = () => {
	return (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<title>default avatar icon</title>
			<rect width="24" height="24" rx="12" fill="#E2E8F0" />
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M7.70906 15.1516C8.69554 13.846 10.2494 13 12 13C13.7505 13 15.3044 13.846 16.2909 15.1516C16.2954 15.1575 16.2999 15.1634 16.3043 15.1693C16.3892 15.2815 16.4801 15.4018 16.5451 15.5178C16.6238 15.6582 16.6821 15.8207 16.6785 16.0183C16.6756 16.1771 16.6274 16.3258 16.569 16.4432C16.5106 16.5606 16.4209 16.6886 16.296 16.7867C16.1293 16.9175 15.9479 16.9638 15.7867 16.9831C15.6452 17.0001 15.4777 17 15.3092 17C15.3016 17 15.294 17 15.2864 17H8.7136C8.70601 17 8.69842 17 8.69082 17C8.52232 17 8.35473 17.0001 8.21331 16.9831C8.05211 16.9638 7.87066 16.9175 7.704 16.7867C7.57903 16.6886 7.48941 16.5606 7.43097 16.4432C7.37254 16.3258 7.32441 16.1771 7.32151 16.0183C7.3179 15.8207 7.3762 15.6582 7.45487 15.5178C7.51986 15.4018 7.61081 15.2815 7.69563 15.1693C7.70012 15.1634 7.7046 15.1575 7.70906 15.1516Z"
				fill="white"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M9.24999 9.75C9.24999 8.23122 10.4812 7 12 7C13.5188 7 14.75 8.23122 14.75 9.75C14.75 11.2688 13.5188 12.5 12 12.5C10.4812 12.5 9.24999 11.2688 9.24999 9.75Z"
				fill="white"
			/>
		</svg>
	);
};

export default DefaultAvatarIcon;
